import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const SharedSocialLine = () => {
    //hooks
    const { t } = useTranslation();

    return (
        <StyledSocialLine>
            <div className="line_left"></div>
            <div className="text">{t("page.or")}</div>
            <div className="line_right"></div>
        </StyledSocialLine>
    );
};

const StyledSocialLine = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    max-width: 450px;
    margin-top: 25px;
    margin-bottom: 15px;

    .line_left,
    .line_right {
        height: 1px;
        background-color: #a5a5a5;
        flex: 1;
    }
    .text {
        font-weight: 600;
        font-size: 20px;
        color: #a5a5a5;
        margin: 0 12px;
    }
`;
